module.exports = __webpack_public_path__ + "static/media/ΧΡΙΣΤΟΥΓΕΝΝΙΑΤΙΚΗ ΙΣΤΟΡΙΑ.15dc6c0f.mp4";